(function(app) {
    'use strict';

    const elements = {
        fontSelectEl: null,
        fontDisplayEl: null
    };

    app.FontSelection = {
        init() {
            elements.fontSelectEl = document.querySelector('.wdpp-select--font-family');
            elements.fontDisplayEl = document.querySelector('.wdpp-display--font');
            
            // Validate required elements
            if (!app.Utils.validateElements('font inputs', {
                'font select element': '.wdpp-select--font-family',
                'font display element': '.wdpp-display--font'
            })) {
                return;
            }

            // Set initial font family style
            elements.fontSelectEl.style.setProperty('font-family', elements.fontSelectEl.value, 'important');

            // Style all options with their respective fonts
            Array.from(elements.fontSelectEl.options).forEach(option => {
                option.style.setProperty('font-family', option.value, 'important');
            });

            elements.fontSelectEl.addEventListener('change', () => {
                // Remove selected attribute from all options
                Array.from(elements.fontSelectEl.options).forEach(opt => {
                    opt.removeAttribute('selected');
                });

                // Set selected attribute on chosen option
                const selectedOption = elements.fontSelectEl.options[elements.fontSelectEl.selectedIndex];
                if (selectedOption) {
                    selectedOption.setAttribute('selected', '');
                    app.Store.setState('font', elements.fontSelectEl.value);
                }
            });

            // Update font previews if text exists
            const text = app.Store.getState('text');
            if (text) {
                this.updateFontPreviews(text);
            }

            // Subscribe to store changes
            app.Store.subscribe('font', (font) => this.updateFontDisplay(font));
            app.Store.subscribe('text', (text) => this.updateFontPreviews(text));

            // Set initial font in store
            if (elements.fontSelectEl.value) {
                app.Store.subscribe('initialized', () => {
                    app.Store.setState('font', elements.fontSelectEl.value);
                });
            }
        },

        updateFontDisplay(font) {
            if (elements.fontDisplayEl) {
                elements.fontDisplayEl.textContent = font;
                elements.fontDisplayEl.style.setProperty('--display-font-family', font);
            }
            if (elements.fontSelectEl) {
                elements.fontSelectEl.style.setProperty('font-family', font, 'important');
            }
        },

        updateFontPreviews(text) {
            // if (elements.fontSelectEl && elements.fontSelectEl.dataset.textFontPreview !== '' && text) {
            if (elements.fontSelectEl) {
                Array.from(elements.fontSelectEl.options).forEach(option => {
                    option.textContent = text ? `${text.slice(0, 10)} (${option.value})` : `${option.value}`;
                });
            }
        },

        getFonts() {
            if (!elements.fontSelectEl) {
                return [];
            }

            return Array.from(elements.fontSelectEl.options).map(option => option.value);
        },
        
        /**
         * Get the font data for cart export
         * @returns {object} The font data for the cart
         */
        getCartData() {
            return {
                font: app.Store.getState('font') || ''
            };
        },

        /**
         * Get the font data for price calculation
         * @returns {object} The font data for the price
         */
        getPriceData() {
            return {
                font: app.Store.getState('font') || ''
            };
        }
    };
})(window.app = window.app || {});